import {AbstractController} from "../../../controllers/AbstractController";
import {INavigatorBarController, MK_NAVIGATOR_BAR} from "./INavigatorBarController";
import {inject, Injectable, signal} from "@angular/core";
import {ControllerEventBus} from "../../../event-buses/controller.event-bus";
import {NavigatorBarItems} from "../_event-buses/event-data/NavigatorBarItems";
import {ControllerEvent} from "../../../event-buses/ControllerEvent";
import {NavigatorBarItem} from "../_interfaces/NavigatorBarItem";
import {NavigatorBarControllerEventName} from "../_event-buses/NavigatorBarControllerEventName";
import {Helper} from "../../../helpers/Helper";

@Injectable()
export abstract class AbstractNavigatorBarController extends AbstractController implements INavigatorBarController {

  protected constructor(controllerEventBus: ControllerEventBus) {
    super(controllerEventBus);

    this.addModel(MK_NAVIGATOR_BAR, {
      items$: signal([]),
    });

    this.subscribe(NavigatorBarControllerEventName.NavigatorBarItems, (event) => {
      this.onNavigatorBarItems(event);
    });
  }

  handleInit(eventData: any): void {
    const items: Array<NavigatorBarItem>|undefined|null = eventData['items'];

    if(items) {
      this.processItems(items);
    }
  }

  handleItemSelection(eventData: any): void {
    const item: NavigatorBarItem = eventData['item'];
    const event: any = eventData['event'];

    if(item.type === 'url') {
      if(Helper.isValid(item.url)) {
        this.navigate(item.url!, event);
      }
    }
    else if(item.type === 'action') {
      if(Helper.isValid(item.name)) {
        const model = this.getModel(MK_NAVIGATOR_BAR);
        const items = model.items$();

        items.forEach((item) => {
          if(item.type === 'action') {
            item.active = false;
          }
        });

        item.active = true;

        model.items$.set(items);

        this.emit(new ControllerEvent(NavigatorBarControllerEventName.NavigatorBarItemSelected, {
          name: item.name,
        }));
      }
    }
  }

  onNavigatorBarItems(event: ControllerEvent): void {
    const eventData: NavigatorBarItems = event.eventData;
    const items = eventData.items;

    this.processItems(items);
  }

  protected processItems(items: Array<NavigatorBarItem>): void {
    if(items && items.length > 0) {
      const model = this.getModel(MK_NAVIGATOR_BAR);

      items = this.filterItemsByAccessControl(items);

      items = this.filterIrrelevantSeparators(items);

      this.markActiveItem(items);

      model.items$.set(items);
    }
  }

  protected filterItemsByAccessControl(items: Array<NavigatorBarItem>): Array<NavigatorBarItem> {
    return items.filter((item) => {
      if(item.accessName) {
        if(!this.hasAccess(item.accessName)) {
          return false;
        }
      }

      return true;
    });
  }

  protected filterIrrelevantSeparators(items: Array<NavigatorBarItem>): Array<NavigatorBarItem> {
    return items.filter((item, index) => {
      if(item.type === 'separator') {
        const previousItem = items[index - 1];
        const nextItem = items[index + 1];

        if(previousItem && nextItem && previousItem.type !== 'separator' && nextItem.type !== 'separator') {
          return true;
        }
        else {
          return false;
        }
      }

      return true;
    });
  }

  protected markActiveItem(items: Array<NavigatorBarItem>): void {
    const currentUrl = this.getCurrentUrl();

    items.forEach((item) => {
      if(item.type === 'url') {
        if(item.url === currentUrl) {
          item.active = true;
        }
        else {
          item.active = false;
        }
      }
    });
  }
}
